import { Injectable } from '@angular/core';
import {
  InstitutionsFilterInput,
  InstitutionsSearchGQL,
} from 'src/generated/graphql';

@Injectable()
export class InstitutionsService {
  constructor(private institutionsSearchGQL: InstitutionsSearchGQL) {}

  public getInstitutions(filterInput: InstitutionsFilterInput) {
    return this.institutionsSearchGQL.fetch(
      { filters: filterInput },
      { fetchPolicy: 'network-only' }
    );
  }
}
